import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface FilterRanges {
  rank: [number, number];
  score: [number, number];
  gradRate: [number, number];
  socialMobility: [number, number];
}

interface DashboardFilters {
  search: string;
  ranges: FilterRanges;
}

interface University {
  university: string;
  national_rank: number;
  overall_score: number;
  grad_rate: number;
  retention_rate: number;
  peer_assessment: number;
  faculty_resources_rank: number;
  financial_resources_rank: number;
  [key: string]: any;
}

export function useDashboard(filters: DashboardFilters) {
  const fetchUniversities = async () => {
    let query = supabase
      .from('US News University Rankings')
      .select('*')
      .order('national_rank', { ascending: true });

    // Apply filters
    if (filters.search) {
      query = query.ilike('university', `%${filters.search}%`);
    }

    // Apply range filters
    query = query
      .gte('national_rank', filters.ranges.rank[0])
      .lte('national_rank', filters.ranges.rank[1])
      .gte('overall_score', filters.ranges.score[0])
      .lte('overall_score', filters.ranges.score[1])
      .gte('grad_rate', filters.ranges.gradRate[0])
      .lte('grad_rate', filters.ranges.gradRate[1])
      .gte('social_mobility_rank', filters.ranges.socialMobility[0])
      .lte('social_mobility_rank', filters.ranges.socialMobility[1]);

    const { data, error } = await query;

    if (error) {
      throw error;
    }

    return data as University[];
  };

  const { data: universities, isLoading, error } = useQuery({
    queryKey: ['universities', filters],
    queryFn: fetchUniversities,
  });

  return {
    universities,
    isLoading,
    error,
  };
} 